import { User } from '@shared/modules/auth/classes/User';

export interface UserState {
  me: User;
}

export const userInitialState: UserState = {
  me: undefined,
};
